
import { Urls } from "@share/constants";
import { axiosInstance} from "@share/utils";
import { IAccount } from "../common-types/account";





export const AddCompanyCreditCard = (data: any, account: IAccount) => {
    const month = data?.expireDate?.substring(0, 2);
    const year = data.expireDate?.substring(data.expireDate.length - 4);

    return axiosInstance.post(Urls.CompanyCards, {
        billing: {
            address: {
                line1: data?.addressLine,
                city: data?.city,
                country: data?.country,
                state: data?.state,
                postalCode: data?.zipCode
            },
            email: account?.email,
            phone: data?.phone,
            name: data?.holderName
        },
        Card: {
            Number: data?.cardNumber,
            ExpMonth: month,
            ExpYear: year,
            CVC: data?.cvv
        }
    });
}

export const DeleteCompanyCreditCard = (paymentId: any) => {
    return axiosInstance.delete(`${Urls.CompanyCards}/${paymentId}`);
}